module.exports = __webpack_public_path__ + "files/5eee9724e30560bef08d01b98f922569.svg";